module.exports = __webpack_public_path__ + "img/ic_add_file_3_active.ea817697.svg";